export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_SUCCESS_TYPE = 'ORDER_SUCCESS_TYPE';
export const UPDATE_TRADE_SOCKET_DATA = 'UPDATE_TRADE_SOCKET_DATA';
export const HIDE_MODAL = 'HIDE_MODAL';
export const LOAD_TRADE_SOCKET_DATA = 'LOAD_TRADE_SOCKET_DATA';
export const CLOSE_SOCKET_TRADE = 'CLOSE_SOCKET_TRADE';
export const EXECUTE_SUCCESS = 'EXECUTE_SUCCESS';
export const GETBM='GETBM';
export const GETBM_SUCCESS='GETBM_SUCCESS';
export const GETBM_FAILURE='GETBM_FAILURE';
export const SHOW_ALERT='SHOW_ALERT';
export const HIDE_ALERT='HIDE_ALERT';
export const TRD_STATUS='TRD_STATUS';
export const CUTOFF_BENCHMARK='CUTOFF_BENCHMARK';
export const UPDATE_BM_LIST='UPDATE_BM_LIST';
export const UPDATE_POPOUT_COUNT='UPDATE_POPOUT_COUNT';
export const CLOSE_WEBSOCKET_TRADE = 'CLOSE_WEBSOCKET_TRADE';
export const CANCEL_PAYMENT_REQUEST='CANCEL_PAYMENT_REQUEST';
export const MODIFY_PAYMENT_REQUEST='MODIFY_PAYMENT_REQUEST';
export const ADD_PAYMENT_REQUEST = 'ADD_PAYMENT_REQUEST';
export const PAYMENT_FAILED_FLAG = 'PAYMENT_FAILED_FLAG';
export const PLACE_FWD_TRADE ='PLACE_FWD_TRADE';
export const PLACE_FWD_TRADE_SUCCESS = 'PLACE_FWD_TRADE_SUCCESS';
export const PLACE_FWD_TRADE_FAILURE = 'PLACE_FWD_TRADE_FAILURE';
export const PLACE_SWP_TRADE ='PLACE_SWP_TRADE';
export const PLACE_SWP_TRADE_SUCCESS = 'PLACE_SWP_TRADE_SUCCESS';
export const PLACE_SWP_TRADE_FAILURE = 'PLACE_SWP_TRADE_FAILURE';
export const ACC_DEACTIVATION_UPDATE = 'ACC_DEACTIVATION_UPDATE';
export const CLEAR_ACC_DEACTIVATION = "CLEAR_ACC_DEACTIVATION";
